import React from "react";
import { ChevronDown, Square } from "lucide-react";
import Modal from "./Modal";
import SplitLegend from "./SplitLegend";
import "./LegendModal.scss";

interface LegendModalProps {
  handleClose: () => void;
}

// How to read and use the items on the shared check: the claim box, the
// caret, and what the donut colors mean. Opened from the Legend button by
// "2. Select the items that you got".
const LegendModal: React.FC<LegendModalProps> = ({ handleClose }) => (
  <Modal className="legend-modal" title="Legend" handleClose={handleClose}>
    <div className="legend-section">
      <div className="legend-row">
        <span className="legend-sample claim-box needs-claim">
          tap to claim
        </span>
        <span>tap the box to claim a portion</span>
      </div>
      <div className="legend-row">
        <span className="legend-sample claim-box claimed">tap to unclaim</span>
        <span>tap again to give it back</span>
      </div>
      <div className="legend-row">
        <span className="legend-sample">
          <ChevronDown size={16} className="legend-caret" />
        </span>
        <span>tap the caret to split an item</span>
      </div>
      <div className="legend-row">
        <span className="legend-sample">
          <Square size={18} className="legend-checkbox" />
        </span>
        <span>select multiple items to set their splits together</span>
      </div>
    </div>

    <div className="legend-section">
      <SplitLegend />
    </div>

    <button className="modal-button" onClick={handleClose}>
      Done
    </button>
  </Modal>
);

export default LegendModal;
